import { useParams } from 'react-router';
import { StaffFleetGrid } from '../components/StaffFleetGrid';
import { useStaffCustomerFleets } from '../hooks/useStaffCustomer';

export function CustomerFleetsPage() {
  const { accountId } = useParams();
  const { data, loading, error } = useStaffCustomerFleets(accountId);
  const fleets = data?.staffCustomerFleets ?? [];

  if (error) {
    return (
      <div className="rounded-md border border-destructive/30 bg-destructive/5 p-4 text-sm text-destructive">
        {error.message}
      </div>
    );
  }

  return (
    <div data-testid="customer-fleets-page">
      <StaffFleetGrid fleets={fleets} loading={loading} />
    </div>
  );
}
